export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_it.250799d07e0852c7.json"